import React from 'react';
import { Flex } from '@chakra-ui/react';

export const ScrollableTable = ({ children }) => (
  <Flex
    role="table"
    flexDirection="column"
    overflowY="auto"
    sx={{
      '&::-webkit-scrollbar': {
        width: '4px',
        borderRadius: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'primary.200',
      },
    }}
  >
    {children}
  </Flex>
);
